/**
 * White rounded section wrapper for Match Hub cards.
 */

import React, { useMemo } from 'react';
import { Text, View, type StyleProp, type TextStyle, type ViewStyle } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { getSectionCardStyles } from './SectionCard.styles';

export interface SectionCardProps {
  /** Omit or leave empty to hide the title row (card body only). */
  title?: string;
  children: React.ReactNode;
  testID?: string;
  /** Optional right side of the title row (e.g. column headers). */
  titleRight?: React.ReactNode;
  /** Merged after the default title style (e.g. smaller heading for dense cards). */
  titleStyle?: StyleProp<TextStyle>;
  titleRowStyle?: StyleProp<ViewStyle>;
  /** Merged after default card container (e.g. tighter padding). */
  cardStyle?: StyleProp<ViewStyle>;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  children,
  testID,
  titleRight,
  titleStyle,
  titleRowStyle,
  cardStyle,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => getSectionCardStyles(theme), [theme]);

  const hasTitleText = Boolean(title?.trim());
  const showTitleRow = hasTitleText || titleRight != null;

  return (
    <View style={[styles.card, cardStyle]} testID={testID}>
      {showTitleRow ? (
        <View style={[styles.titleRow, titleRowStyle]}>
          {hasTitleText ? (
            <Text style={[styles.title, titleStyle]}>{title}</Text>
          ) : null}
          {titleRight}
        </View>
      ) : null}
      {children}
    </View>
  );
};
